import { useState } from 'react';
import { AutoPopupModal } from '@/components/widgets/modal';
import Image from 'next/image';
import { useRouter } from '@/navigation';
import { useLocale } from 'next-intl';
import { siteService } from '@/services/site.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { Icon } from '@/components/icons/svg-icons';
import { useAccountInfo } from '@/hooks/query/account';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { AccountActStatus } from '@nf/utils-common/constants';
import { AutoPopupKey } from '@nf/auto-popup-handler';

export const BoxingPromoModal = () => {
	const router = useRouter();
	const locale = useLocale();
	const [isOpen, setIsOpen] = useState(true);
	const { SiteConfigsData } = useGetSiteConfigs();
	const { user } = useAccountInfo();
	const disableStorageKey = 'boxing_promotion_popup_closed';
	const isDisableBoxingPromotion = localStorage.getItem(disableStorageKey) === 'true';

	const isGameDay = () => {
		const currentTime = new Date();
		const startTime = new Date(Date.UTC(2024, 10, 16, 0-8, 0, 0));
		const endTime = new Date(Date.UTC(2024, 10, 16, 23-8, 59, 59));
		
		return startTime <= currentTime && currentTime <= endTime;
	}

	const enableBoxingPromotion = user?.LicenseeSiteSetting?.EnableBoxingPromotion && isGameDay();

	const disablePopup = () => {
		localStorage.setItem(disableStorageKey, 'true');
	}

	const closeModal = () => {
		disablePopup();
		setIsOpen(false);
	}

	const gotoStreamerPage = () => {
		disablePopup();
		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: 18,
			action: 2
		}
		setKafkaNormal(kafkaData);
		router.push('streamer?type=2', { locale });
		setIsOpen(false);
	}

	const imagePath = () => {
		let imageName;
		switch (locale) {
			case 'zh-CN':
			case 'zh-Hans':
			case 'zh-TW':
				imageName = 'cs'
				break;
			case 'th-TH':
				imageName = 'th'
				break;
			case 'vi-VN':
				imageName = 'vn'
				break;
			default:
				imageName = 'en';
		}

		return siteService.combineImagePath(`/images/promo-modals/boxing-promo/${imageName}.png`, true, SiteConfigsData);
	}

	return (
		<AutoPopupModal
			popupKey={AutoPopupKey.BoxingPromo}
			isOpen={isOpen && !!(enableBoxingPromotion && user?.ActStatus === AccountActStatus.Deposited && !isDisableBoxingPromotion)}
			variant="event"
			closeModal={closeModal}
			showHeader={false}
			className="promo-modals"
		>
			<div className="promo-modals__wrap">
				<div
					className="promo-modals__close-btn"
					onClick={closeModal}
				>
					<Icon name="close-round-line" />
				</div>
				<div className="promo-modals__image" onClick={gotoStreamerPage}>
					<Image src={imagePath()} width={300} height={500} alt="" />
				</div>
			</div>
		</AutoPopupModal>
	);
}